exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-size-price{\n    font-size: 2rem;\n    color:darkblue !important;\n}\n.font-size-0-8{\n    font-size: 0.8rem;\n}\n.text-indent{\n    text-indent: 1.5em;\n}\n.text-head{\n    color: black;\n    font-size: 0.8rem;\n}\n.text-rule{\n    color: #b3b3b3;\n}\n@media (max-width:514px){\n    .mobile-box{\n        margin-top: -1%;\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/detail-item/detail-item.component.css
// module id = ../../../../../src/app/components/detail-item/detail-item.component.css
// module chunks = main